/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Selected_OnlyInputs */

const en_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Selected Events Only`)
};

const fr_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser uniquement les événements sélectionnés`)
};

const de_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ausgewählte Ereignisse synchronisieren`)
};

const it_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza solo eventi selezionati`)
};

const ru_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизировать только выбранные события`)
};

const es_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar solo eventos seleccionados`)
};

const zh_cn2_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅同步已选择事件`)
};

const ja_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントのみ同期`)
};

const hi_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल चयनित इवेंट सिंक करें`)
};

const pt_pt2_offline_sync_selected_only = /** @type {(inputs: Offline_Sync_Selected_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar apenas eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Sync Selected Events Only" |
*
* @param {Offline_Sync_Selected_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_selected_only = /** @type {((inputs?: Offline_Sync_Selected_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Selected_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_selected_only(inputs)
	if (locale === "de") return de_offline_sync_selected_only(inputs)
	if (locale === "it") return it_offline_sync_selected_only(inputs)
	if (locale === "ru") return ru_offline_sync_selected_only(inputs)
	if (locale === "es") return es_offline_sync_selected_only(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_selected_only(inputs)
	if (locale === "ja") return ja_offline_sync_selected_only(inputs)
	if (locale === "hi") return hi_offline_sync_selected_only(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_selected_only(inputs)
	return en_offline_sync_selected_only(inputs)
});